import { responseSurveyStore } from "../stores/response-survey.store";

export const useResponseSurveyStore = () => responseSurveyStore;
